<template lang="pug">
div(
  ref="scroller"
  :style="styles"
  @scroll.passive="debouncedHandleScroll"
)
  slot
  .text-center(ref="loadMore")
    slot(name="loadMore")
    a.load-more-link.btn.btn-outline-primary.btn-sm(
      v-if="showMoreLink"
      href="#"
      @click="handleLoadMore"
    ) Load more
</template>

<script>
import debounce from 'lodash-es/debounce';

export default {
  name: 'AppInfiniteScroll',
  props: {
    maxHeight: {
      type: String,
      required: true,
      default: '20em',
    },
    allowance: {
      type: Number,
      default: 20,
    },
    scrollPadding: {
      type: Number,
      default: 100,
    },
    showMoreLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrollTimeout: null,
      debouncedHandleScroll: null,
    };
  },
  computed: {
    styles() {
      return {
        maxHeight: this.maxHeight,
        overflowY: this.autoHeight() ? 'initial' : 'auto',
      };
    },
  },
  mounted() {
    this.debouncedHandleScroll = debounce(this.handleScroll, 500);
    if (this.autoHeight() && this.hasWindow()) {
      window.addEventListener('scroll', this.debouncedHandleScroll);
    }
  },
  updated() {
    if (!this.showMoreLink) {
      this.debouncedHandleScroll();
    }
  },
  beforeDestroy: function () {
    if (this.autoHeight() && this.debouncedHandleScroll && this.hasWindow()) {
      window.removeEventListener('scroll', this.debouncedHandleScroll);
    }

    if (this.debouncedHandleScroll && this.debouncedHandleScroll.cancel) {
      this.debouncedHandleScroll.cancel();
      this.debouncedHandleScroll = null;
    }
  },
  methods: {
    check() {
      const scroller = this.$refs.scroller;
      const viewportHeight = scroller.clientHeight;
      const contentHeight = scroller.scrollHeight;
      const allowance = Math.max(this.$refs.loadMore.clientHeight / 2, this.allowance);
      const atBottom = contentHeight - Math.abs(scroller.scrollTop) - allowance <= viewportHeight;

      if (atBottom) {
        this.$emit('loadmore');
      }
    },
    checkViaViewport() {
      if (!this.$refs.loadMore || !this.hasWindow()) {
        return;
      }

      const pos = this.$refs.loadMore.getBoundingClientRect();
      const inViewport = !(pos.top - this.scrollPadding > window.innerHeight || pos.bottom < 0);

      if (inViewport) {
        this.$emit('loadmore');
      }
    },
    handleScroll() {
      this.autoHeight() ? this.checkViaViewport() : this.check();
    },
    autoHeight() {
      return this.maxHeight === 'auto';
    },
    handleLoadMore(ev) {
      ev.preventDefault();
      this.debouncedHandleScroll();
    },
    hasWindow() {
      return typeof window !== 'undefined';
    },
  },
};
</script>
